<template>
  <div class="recharge-record container-fluid">
    <div class="recharge-title">{{ $t('rechargeRecords') }}</div>
    <div class="no-record" v-show="hasFetch && records.length === 0 && !loading">{{ $t('noRechargeRecords') }}</div>
    <div class="no-record" v-show="!hasFetch && records.length === 0">{{$t('is_loading')}}</div>

    <div id="list-box" v-if="records.length > 0">
      <div class="little-title records" id="title">
        <p class="time">{{ $t('time') }}</p>
        <p class="type">{{ $t('memberType') }}</p>
        <p class="item">{{ $t('item') }}</p>
        <p class="amount">{{ $t('amount') }}</p>
        <p class="status">{{ $t('status') }}</p>
        <p class="method">{{ $t('paymentMethods') }}</p>
        <p class="invoice">{{ $t('invoice') }}</p>
      </div>
      <div class="records" v-for="item in records">
        <p class="time">{{ item.created_at | createFormatTime(item.created_at) }}</p>
        <p class="type">{{ item.type }}</p>
        <p class="item">{{ item.order_detail.plan_name }}({{ item.order_detail.device_count }} {{ $tc('devices',item.order_detail.device_count) }})</p>
        <p class="amount">{{ item.order_detail.currency_symbol }}{{item.order_detail.total_amount }}</p>
        <p class="status">{{ $t(item.status) }}</p>
        <p class="method" v-if="item.payment_method_id === 'alipay_global' || item.payment_method_id === 'wechatpay'">{{ $t(item.payment_method_id) }}</p>
        <p class="method" v-else>{{ item.payment_method_name }}</p>
        <p class="invoice"><a :href="getInvoiceDownloadLink(item.id)">{{ $t('invoice') }}</a></p>
      </div>
    </div>

    <div id="pager-bar" v-if="records.length > 0">
      <div class="spinner-component-box"><spinner :show="loading"></spinner></div>
      <pager mode="event" :total-page="totalPage" :init-page="currentPage" @go-page="queryData"></pager>
    </div>
  </div>
</template>
<script>
  import {createFormatTime} from 'src/lib/filters'
  import pager from '../../components/pager/Index.vue'
  import Spinner from '../../components/Spinner.vue'
  import {getApiHost} from '../../lib/getApiHost'
  import locales from './lang'

  export default {
    name: 'recharge-record-pc',
    components: {Spinner, pager},
    props: ['initData', 'hasFetch'],
    data() {
      return {
        records: [],
        totalPage: 0,
        currentPage: 1,
        loading: false
      }
    },
    locales,
    watch: {
      initData() {
        this.records = this.initData.body.data
        this.currentPage = this.initData.body.meta['current_page']
        this.totalPage = Math.ceil(this.initData.body.meta['total'] / this.initData.body.meta['per_page'])
      }
    },
    methods: {
      queryData(data) {
        this.loading = true
        this.$http.get('api/topup-records?page=' + data.page).then((response) => {
          this.loading = false
          this.records = response.data.data
          this.currentPage = response.data.meta['current_page']
          this.totalPage = Math.ceil(response.data.meta['total'] / response.data.meta['per_page'])
        }, (response) => {
          this.loading = false
        })
      },
      getInvoiceDownloadLink(orderId) {
        return `${getApiHost()}/api/topup-order/${orderId}/invoice`
      }
    },
    filters: {createFormatTime}
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/scss/variables";

  * {
    padding: 0;
    margin: 0;
  }

  .recharge-record {
    border: 1px solid #E0D7E3;
    border-radius: .08rem;
  }
  .no-record {
    margin: .8rem auto 1.8rem;
    text-align: center;
    color: #666;
  }
  #pager-bar {
    padding-bottom: .4rem;
    .spinner-component-box {
      min-height: .8rem;
      padding: .1rem 0;
    }
  }

  .recharge-title {
    height: .48rem;
    line-height: .48rem;
    padding: 0 .16rem;
    font-size: .16rem;
    color: #111;
    letter-spacing: 0;
    border-bottom: 1px solid #E0D7E3;
    border-radius: 0;
  }

  #list-box {
    min-height: 4.5rem;
  }
  .little-title {
    line-height: .2rem;
    padding: .17rem 0;
    font-size: 0;
    letter-spacing: 0;
    p{
      color: #333 !important;
    }
  }
  .records {
    line-height: .2rem;
    padding: .17rem 0;
    border-bottom: .01rem solid #E0D7E3;
    font-size: 0;
    p {
      text-align: center;
      display: inline-block;
      font-size: .14rem;
      letter-spacing: 0;
      color: #666;
      &:first-child {
        padding: 0 0 0 .2rem;
      }
      &:last-child {
        margin: 0;
        padding: 0 .2rem 0 0;
      }
      &.time {
        width: calc((100% - 1.3rem) * .20);
      }
      &.type {
        width: calc((100% - 1.3rem) * .15);
      }
      &.item {
        width: calc((100% - 1.3rem) * .20);
      }
      &.amount {
        width: calc((100% - 1.3rem) * .15);
      }
      &.status {
        width: calc((100% - 1.3rem) * .15);
      }
      &.method {
        width: calc((100% - 1.3rem) * .15);
      }
      &.invoice {
        width: 1.3rem;
        a {
          color: #416CF8;
          text-decoration: underline;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// RechargeRecordPc.vue?8dbdee3a